import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNoAuth } from "../config/axiosInstance";

export const fetchSubscriptionStatus = createAsyncThunk(
    'subscriptionStatus/fetchSubscriptionStatus',
    async ({ email }) => {
        const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/user_account_status', {
            params: {
                email: email
            }
        })
        return response.data
    }
)

export const fetchSubscriptionStatusWithPolling = createAsyncThunk(
    'subscriptionStatus/fetchSubscriptionStatusWithPolling',
    async ({ email, pollingInterval = 2000, maxAttempts = 30 }, { rejectWithValue }) => {
        const pollAPI = async (attempt = 1) => {
            try {
                const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/user_account_status', {
                    params: { email: email }
                });
                
                // If we get a 200 response, return the data
                if (response.status === 200) {
                    return response.data;
                }
                
                // If not 200 but no error thrown, continue polling
                throw new Error(`Received status ${response.status}, continuing to poll...`);
                
            } catch (error) {
                console.log(`Subscription status polling attempt ${attempt}/${maxAttempts} failed:`, error.message);
                
                // If we've reached max attempts, reject with error
                if (attempt >= maxAttempts) {
                    console.error('Max polling attempts reached for subscription status');
                    const message = error?.response?.data || error?.message || 'Failed to fetch subscription status after polling';
                    throw new Error(message);
                }
                
                // Wait for the polling interval before next attempt
                await new Promise(resolve => setTimeout(resolve, pollingInterval));
                
                // Recursively call with incremented attempt count
                return pollAPI(attempt + 1);
            }
        };
        
        try {
            return await pollAPI();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

const initialState = {
    is_locked: false,
    type: '',
    loading: false,
    error: null
}

const subscriptionStatusSlice = createSlice({
    name: 'subscriptionStatus',
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.is_locked = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSubscriptionStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                Object.assign(state, action.payload);
            })
            .addCase(fetchSubscriptionStatusWithPolling.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSubscriptionStatusWithPolling.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                Object.assign(state, action.payload);
            })
            .addCase(fetchSubscriptionStatusWithPolling.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export const { setStatus } = subscriptionStatusSlice.actions
export const selectSubscriptionStatus = (state) => state.subscriptionStatus
export default subscriptionStatusSlice.reducer